// extracted by mini-css-extract-plugin
export var image = "UpdateCard-module--image--bd734";
export var imageEffects = "UpdateCard-module--imageEffects--5f111";
export var imageWrapper = "UpdateCard-module--imageWrapper--73943";
export var root = "UpdateCard-module--root--fecf7";